import { render } from "./SEOComponent.vue?vue&type=template&id=ca31d6c8"
import script from "./SEOComponent.vue?vue&type=script&lang=js"
export * from "./SEOComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__